module.exports = __webpack_public_path__ + "static/media/C02.00613dbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/decors/C02.png
// module id = 207
// module chunks = 0